import React from "react";
import ReportCard from "../../components/ui/ReportCard";
import { ArrowUpIcon } from "@chakra-ui/icons";

export default function QueriedReports() {
  return (
    <ReportCard text={100} icon={<ArrowUpIcon />} title="Queried Reports" />
  );
}
